"use client"

import { useEffect } from "react"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8">
      <div className="text-lg font-semibold text-foreground">Something went wrong</div>
      <button
        onClick={reset}
        className="rounded-lg border border-border bg-muted px-4 py-2 text-sm text-foreground hover:bg-muted/80"
      >
        Try again
      </button>
    </div>
  )
}
